import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import Sector from '../../components/sector/Sector';
import Product from '../../components/product/Product';

const MAXIMUM_VISIBLE_RESULTS = 50;

class SearchPage extends React.Component {

    state = {
        query: null,
        products: null,
        showAll: false
    }

    componentDidMount() {
        this.setState({
            query: appSettingsSearch.query,
            sectors: appSettingsSearch.sectors,
            products: appSettingsSearch.products,
        });
    }

    handleChange = (e) => {
        this.setState({
            query: e.currentTarget.value
        });
    }

    render() {
        const {props: {basket: {items, totalPrice}}, state: {query, products, showAll}, handleChange} = this;

        //first render
        if (products === null) {
            return null;
        }

        let displayedProducts = products;

        if (!showAll && products.length > 2 * MAXIMUM_VISIBLE_RESULTS) { //2x protoze proste dvojnasobek taky neni problem, ale tisice jo
            displayedProducts = products.slice(0, MAXIMUM_VISIBLE_RESULTS);
        }

        return (
                <React.Fragment>
                
                    <header className="header">
                
                        {!appSettingsSearch.query && <h2>S čím vám môžeme pomôcť?</h2>}
                        {appSettingsSearch.query && <h2>{products.length} nájdených produktov</h2>}
                
                        <form role="search" action={this.props.settings.links.searchLink} >
                            <input type="text" 
                                   name="q"
                                   onChange={handleChange} 
                                   value={query}
                                   autoComplete="off" 
                                   placeholder="Hľadaný výraz ..."/>
                
                            <button type="submit" >
                                <span className="glyphicon glyphicon-search "></span> 
                            </button>
                        </form>
                    </header>
                    
                        <ul className="product-list">
                            {displayedProducts.map(product => {

                                const basketItemArr = items.filter(i => i.catalogNumber === product.catalogNumber);
                                const qty = basketItemArr.length > 0 ? basketItemArr[0].qty : 0;

                                return <Product key={product.id} qty={qty} product={product} />;
                            })}
                        </ul>
                    
                    <div className="footer">
                
                        <div className="pagination">
                            Zobrazené 0 - {displayedProducts.length} z {products.length}
                        </div>
                
                        {!showAll && products.length > displayedProducts.length &&
                            <a onClick={e => this.setState({showAll: true}) } className="btn btn-sm btn-basket plus">
                                Zobraziť všetko<i className="glyphicon glyphicon-menu-right"></i>
                            </a>
                        }
                    </div> 
                
                </React.Fragment>
                );
    }
}

const mapStateToProps = (state) => ({
    basket: state.basket,
    settings: state.settingsReducer
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);